import type { I18nDictionaryShape } from '../../types';
import type { commonEnGb } from '../en-GB/common';

export const commonRoRo = {
  brand: {
    logoAlt: 'Logo Safi',
    name: 'Safi',
    vatLabel: 'TVA Safi',
  },
  currencySelectField: {
    groups: {
      other: 'Altele',
      suggested: 'Sugerate',
    },
  },
  domains: {
    evidence: 'Dovezi',
    evidenceLower: 'dovezi',
    qualityControl: 'Controlul calității',
    qualityControlLower: 'controlul calității',
  },
  values: {
    emptyValue: '-',
  },
} satisfies I18nDictionaryShape<typeof commonEnGb>;
